import API from '../api/index.ts';
import QueryParams from '../support/UrlQueryParam/index.ts';
import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class EventsListing extends MainClass {
	private tagsFilter: HTMLElement[];
	private urlQueryParamMethod: QueryParams;
	private TAG_QUERY_NAME: string;
	private EVENT_TYPE_NAME: string;
	private allFilterTagELe: HTMLElement;
	private filterBody: URLSearchParams;
	private eventsWrapper: HTMLElement;
	private dropdownToggle: HTMLInputElement;
	private dropdownContent: HTMLElement;
	private announceResults: HTMLElement;
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.tagsFilter = Array.from( this.selector.querySelectorAll( '.raise-event-tag-filter' ) ) as HTMLElement[];
		this.urlQueryParamMethod = new QueryParams();
		this.TAG_QUERY_NAME = 'event-tag';
		this.EVENT_TYPE_NAME = 'event-type';
		this.allFilterTagELe = this.tagsFilter.find( item => item.getAttribute( 'data-taxo' ) === '0' ) as HTMLElement;
		this.filterBody = new URLSearchParams( window.location.search );
		this.eventsWrapper = this.selector.querySelector( '.raise-events-wrapper' ) as HTMLElement;
		this.announceResults = this.selector.querySelector( '.raise-announce-results' ) as HTMLElement;
		this.dropdownToggle = this.selector.querySelector( '.dropdown-filter-toggle' ) as HTMLInputElement;
		this.dropdownContent = this.selector.querySelector( '.dropdow-content' ) as HTMLElement;
		this.selector && this.init();
	}

	private activeTagByUrlQueryParam = () => {
		const tagIds = this.urlQueryParamMethod.getUrlParameter( this.TAG_QUERY_NAME )
			? this.urlQueryParamMethod.getUrlParameter( this.TAG_QUERY_NAME )
			: [];
		const eventType = this.urlQueryParamMethod.getUrlParameter( this.EVENT_TYPE_NAME )
			? this.urlQueryParamMethod.getUrlParameter( this.EVENT_TYPE_NAME )
			: [];
		if ( tagIds ) {
			this.tagsFilter.forEach( ( catItem: HTMLElement ) => {
				if ( tagIds.includes( Number( catItem.getAttribute( 'data-taxo' ) ) ) ) {
					catItem.classList.add( 'active' );
					this.allFilterTagELe.classList.remove( 'active' );
				}
			} );
		}
		if ( eventType ) {
			const activeEle = this.dropdownContent.querySelector(
				`.option-filter[data-filter="${ eventType[ 0 ] }"]`,
			) as HTMLElement;
			if ( activeEle ) {
				this.dropdownToggle.value = activeEle.innerText;
				this.dropdownToggle.classList.add( 'active' );
			}
		}
	};

	private handleClicktagFilter( tag: HTMLElement ) {
		let categoryFilterParams = [ ...this.urlQueryParamMethod.getUrlParameter( this.TAG_QUERY_NAME ) ];

		if ( categoryFilterParams.includes( Number( tag.getAttribute( 'data-taxo' ) ) ) ) {
			tag.classList.remove( 'active' );
			categoryFilterParams = categoryFilterParams.filter(
				item => item !== Number( tag.getAttribute( 'data-taxo' ) ),
			);
		} else {
			tag.classList.add( 'active' );
			this.allFilterTagELe.classList.remove( 'active' );
			categoryFilterParams = [ ...categoryFilterParams, Number( tag.getAttribute( 'data-taxo' ) ) ];
		}
		if ( tag === this.allFilterTagELe ) {
			this.tagsFilter.forEach( item => {
				item.classList.remove( 'active' );
			} );
			categoryFilterParams = [];
			tag.classList.add( 'active' );
		}
		if ( categoryFilterParams?.length > 0 ) {
			this.filterBody.delete( this.TAG_QUERY_NAME );
			categoryFilterParams.forEach( item => this.filterBody.append( this.TAG_QUERY_NAME, item ) );
		} else {
			this.filterBody.delete( this.TAG_QUERY_NAME );
		}
		this.filterEvents();
		this.urlQueryParamMethod.pushQueryParamsToUrl( this.TAG_QUERY_NAME, categoryFilterParams );
	}
	private filterEvents = async () => {
		try {
			const dataFilter = new API( { feature: 'events/v1' } );
			const body = {
				[ this.TAG_QUERY_NAME ]:
					this.filterBody.getAll( this.TAG_QUERY_NAME ).length > 0
						? this.filterBody.getAll( this.TAG_QUERY_NAME )
						: [],
				[ this.EVENT_TYPE_NAME ]:
					this.filterBody.getAll( this.EVENT_TYPE_NAME ).length > 0
						? this.filterBody.getAll( this.EVENT_TYPE_NAME ).join()
						: [ 'all' ],
			};
			const response = await dataFilter.filter( 'events/v1/filter', body );
			if ( response.data.length > 0 && this.eventsWrapper ) {
				this.eventsWrapper.style.display = 'grid';
				this.eventsWrapper.innerHTML = '';
				this.announceResults.innerText = '';
				this.eventsWrapper.innerHTML = response.data.map( item => item.template ).join( '' );
				this.announceResults.innerText = `${ response.data.length } events`;
			} else {
				this.eventsWrapper.innerHTML = '<div class="raise-no-event">No events found</div>';
				this.eventsWrapper.style.display = 'block';
				this.announceResults.innerText = '0 events';
			}
		} catch ( error ) {
			console.error( 'error', error );
		}
	};
	private handleClickDropdownFilter = ( item: HTMLElement ) => {
		this.dropdownContent.classList.remove( 'active' );
		this.dropdownToggle.classList.add( 'active' );
		this.dropdownToggle.value = item.innerText;
		const currentActive = this.dropdownContent.querySelector( '.option-filter.active' );
		if ( currentActive ) {
			currentActive.classList.remove( 'active' );
		}
		item.classList.add( 'active' );
		const eventTypeValue = item.getAttribute( 'data-filter' ) as string;
		if ( eventTypeValue === 'all' ) {
			this.filterBody.delete( this.EVENT_TYPE_NAME );
			this.urlQueryParamMethod.pushQueryParamsToUrl( this.EVENT_TYPE_NAME, '' );
		} else {
			this.filterBody.delete( this.EVENT_TYPE_NAME );
			this.filterBody.append( this.EVENT_TYPE_NAME, eventTypeValue );
			this.urlQueryParamMethod.pushQueryParamsToUrl( this.EVENT_TYPE_NAME, eventTypeValue );
		}
		this.filterEvents();
	};
	private init() {
		const optionsFilter = Array.from( this.selector.querySelectorAll( '.option-filter' ) ) as HTMLElement[];
		const upCommingFilter = this.dropdownContent.querySelector('li[data-filter="upcoming"]') as HTMLElement;
		
		if ( window.location.search ) {
			this.activeTagByUrlQueryParam();
			this.filterEvents();
		}
		if ( this.tagsFilter.length ) {
			this.tagsFilter.forEach( tag => {
				tag.addEventListener( 'click', () => this.handleClicktagFilter( tag ) );
			} );
		}
		if ( this.dropdownToggle ) {
			this.dropdownToggle.addEventListener( 'click', () => {
				this.dropdownContent.classList.toggle( 'active' );
			} );
		}
		if ( optionsFilter?.length ) {
			optionsFilter.forEach( item => {
				item.addEventListener( 'click', () => this.handleClickDropdownFilter( item ) );
			} );
		}
		if ( upCommingFilter && (!window.location.search || !window.location.search.includes( 'event-type' )) ) {
			upCommingFilter.click();
		}
	}
}

export default EventsListing;
